import { render, staticRenderFns } from "./ExpandTickets.vue?vue&type=template&id=6e9e8714&"
import script from "./ExpandTickets.vue?vue&type=script&lang=js&"
export * from "./ExpandTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports